import { Box } from 'rebass/styled-components';
import { object } from 'prop-types';

import { rem } from '@blueprint/ui';

import { colors } from 'themes';

/**
 * HorizontalRule
 * Adds a horizontal rule between elements
 */
const HorizontalRule = ({ sx, ...rest }) => {
  const { grey } = colors;

  return (
    <Box
      as="hr"
      aria-hidden="true"
      width="100%"
      sx={{
        borderColor: grey,
        marginTop: rem(20),
        borderWidth: rem(1),
        borderStyle: 'none',
        borderTopStyle: 'solid',
        ...sx,
      }}
      {...rest}
    />
  );
};

HorizontalRule.propTypes = {
  /**
   * Extend in the rebass sx values
   */
  sx: object,
};

export default HorizontalRule;
